import { useNavigate, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";

export const SteveFab = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (pathname.startsWith("/assistente")) return null;

  return (
    <button onClick={() => navigate("/assistente")} data-testid="steve-fab" aria-label="Chiedi a Steve"
      className="lg:hidden fixed right-4 bottom-5 z-40 h-14 w-14 rounded-full flex items-center justify-center
        bg-gradient-to-br from-blue-600 to-indigo-500 text-white
        shadow-[0_14px_34px_-10px_rgba(37,99,235,0.9)] ring-1 ring-white/20
        transition-transform duration-200 active:scale-95 hover:scale-105">
      <span className="absolute inset-0 rounded-full bg-cyan-400/30 blur-xl -z-10" />
      <Sparkles className="h-6 w-6" />
    </button>
  );
};
